<script setup lang="ts">
import { StackLayout } from '@/components/Layouts'
import DetectionWrapper from '@/components/Wrappers/DetectionWrapper.vue'
import { type DetectionModel } from '@/types/models/DetectionModel'

type Props = {
    latestDetections?: DetectionModel[]
}

defineProps<Props>()
</script>

<template>
    <StackLayout direction="column" class="device-card-footer">
        <DetectionWrapper :detections="latestDetections ?? []" />
    </StackLayout>
</template>
